import { render, staticRenderFns } from "./PlaceMeta.vue?vue&type=template&id=4fa235c6&scoped=true&"
import script from "./PlaceMeta.vue?vue&type=script&lang=js&"
export * from "./PlaceMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa235c6",
  null
  
)

export default component.exports